import React from 'react';

const DeleteTimeEntryForm = ({ 
    timeEntry,
    onConfirm, 
    onCancel, 
    loading 
}) => {
    if (!timeEntry) return null;

    const formatDuration = () => {
        if (!timeEntry.startTime || !timeEntry.endTime) return '';
        
        const start = new Date(`2000-01-01T${timeEntry.startTime}`);
        const end = new Date(`2000-01-01T${timeEntry.endTime}`);
        const diffMs = end - start;
        const diffHours = diffMs / (1000 * 60 * 60);
        
        return `${diffHours.toFixed(1)}h`;
    };

    const formatDate = () => {
        return new Date(timeEntry.date).toLocaleDateString('de-DE', {
            weekday: 'long',
            day: '2-digit',
            month: '2-digit',
            year: 'numeric'
        });
    };

    return (
        <>
            <div className="overlay" onClick={onCancel}></div>
            <div className="delete-modal">
                <h3>Zeiteintrag löschen</h3>
                
                <div className="entry-details">
                    <div className="detail-row">
                        <strong>Datum:</strong> {formatDate()}
                    </div>
                    <div className="detail-row">
                        <strong>Zeit:</strong> {timeEntry.startTime} - {timeEntry.endTime} ({formatDuration()})
                    </div>
                    {timeEntry.contractTitle && (
                        <div className="detail-row">
                            <strong>Auftrag:</strong> {timeEntry.contractTitle}
                        </div>
                    )}
                    {timeEntry.description && (
                        <div className="detail-row">
                            <strong>Beschreibung:</strong> {timeEntry.description}
                        </div>
                    )}
                </div>

                <div className="warning-message">
                    <p>
                        Sind Sie sicher, dass Sie diesen Zeiteintrag <strong>unwiderruflich löschen</strong> möchten?
                    </p>
                    <p style={{ fontSize: '0.9rem', color: 'var(--third-color)', fontStyle: 'italic' }}>
                        Diese Aktion kann nicht rückgängig gemacht werden.
                    </p>
                </div>

                <div className="modal-actions">
                    <button 
                        type="button" 
                        className="btn btn-secondary" 
                        onClick={onCancel}
                        disabled={loading}
                    >
                        Abbrechen
                    </button>
                    <button 
                        type="button" 
                        className="btn btn-danger"
                        onClick={() => onConfirm(timeEntry)}
                        disabled={loading}
                    >
                        {loading ? 'Löschen...' : 'Endgültig löschen'}
                    </button>
                </div>
            </div>
        </>
    );
};

export default DeleteTimeEntryForm;